export function isMobileBattleViewport() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 767px)").matches;
}

export function mobileBattleToastPosition() {
  return isMobileBattleViewport() ? "bottom-center" : "top-right";
}